// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3Aw2R","item":"PaymentsMobile_item__SZ0nR","label":"PaymentsMobile_label__2dbKj","amount":"PaymentsMobile_amount__2f_My"};